export default "__VITE_ASSET__ad30ea75__"